import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import TochtForm from "./TochtForm";
import Section from "../../common/Section";
import redirector from "../../../util/redirector";
import TochtPageHelper from "./TochtPageHelper";
import { throwException } from "../../../actions/exceptionActions";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import EasterEggHandler from "../../common/EasterEggHandler";
import * as pageConstants from "../../../constants/EasterEggConstants";
import { Modal } from "semantic-ui-react";
import Button from "../../common/Button";
import KopieerTochtGegevensComponent from "./parts/KopieerTochtGegevensComponent";

class TochtPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: {
                gemeenten: [],
                contactpersoon: {}
            },
            federatieEnKoepelOpties: [],
            aangeslotenBijGemeente: [],
            tochtTypes: [],
            errors: null,
            shouldScrollToFirstError: false,
            kopieerModalIsOpen:false,
            fetchedKopieerbareTochten: false,
            organisatorHadAlFederatie: false
        };

        this.testFiller = new EasterEggHandler(this, pageConstants.NIEUWE_TOCHT_BESTAANDE_ORGANISATOR);
        this.pageHelper = new TochtPageHelper(this, redirector);
    }

    componentDidMount = () => {
        this.testFiller.bind();
        super.componentDidMount(); // better way to handle unsaved changes
        this.pageHelper.init();
        window.parent.scrollTo(0, 450);
    };

    componentWillUnmount() {
        this.testFiller.unbind();
    }

    handleOnChange = (event) => this.pageHelper.change(event);

    handleOnChangeDatum = (event) => this.pageHelper.onDatumChange(event);

    handleOnConfirmTeLaatPopup = () => this.pageHelper.confirmTeLaatPopup();

    handleOnChangeLand = (event) => this.pageHelper.onLandChange(event);

    handleOnChangeContactpersoon = (event) => this.pageHelper.onContactpersoonChange(event);

    handleOnChangeTochtType = (event) => this.pageHelper.onTochtTypeChange(event);

    handleOnChangeAangeslotenBij = (event) => this.pageHelper.onAangeslotenBijChange(event);

    handleOnChangeTochtNietViaFederatie = (event) => this.pageHelper.onTochtNietViaFederatieChange(event);

    handleOnChangeContactLand = (event) => this.pageHelper.onContactpersoonLandChange(event);

    handleOnAddGemeente = () => this.pageHelper.onAddGemeente();

    handleOnRemoveGemeente = (index) => this.pageHelper.onRemoveGemeente(index);

    handleOnChangeGemeente = (index, event) => this.pageHelper.onChangeGemeente(index, event);

    handleOnChangeContactpersoonSelection = (event) => this.pageHelper.onChangeContactpersoonSelection(event);

    handleOnSave = () => this.pageHelper.onSave();

    handleOnAnnuleer = () => this.pageHelper.annuleer();

    handleOpenKopieerGegevensTochtModal = () => this.pageHelper.openKopieerGegevensTochtModal();

    handleCloseKopieerGegevensTochtModal = () => this.pageHelper.closeKopieerGegevensTochtModal();

    handleOnSelectTeKopierenTocht = (selectedTochtId) => this.pageHelper.onSelectTeKopierenTocht(selectedTochtId);

    render() {
        const model = this.state.model;
        const federaties = this.state.federatieEnKoepelOpties;
        const hoofdgemeenten = this.state.aangeslotenBijGemeente;
        const contactpersonen = this.state.contactpersonenLabelValuePair;
        const selectedContactpersoon = this.state.selectedContactpersoon;
        const validationMessageType = this.state.validationMessageType;
        const modalHeight = this.state.fetchedKopieerbareTochten ? '665px' : '200px';
        const modalStyle = { bottom: 'auto', top: '50px', height: modalHeight };

        return (<div>
                <TochtForm
                    model={model}
                    federaties={federaties}
                    tochtTypes={this.state.tochtTypes}
                    landen={this.props.landen}
                    gemeenten={this.props.gemeenten}
                    hoofdgemeenten={hoofdgemeenten}
                    postcodes={this.props.postcodes}
                    contactpersonen={contactpersonen}
                    selectedContactpersoon={selectedContactpersoon}
                    onChange={this.handleOnChange}
                    onLandChange={this.handleOnChangeLand}
                    onContactpersoonChange={this.handleOnChangeContactpersoon}
                    onTochtTypeChange={this.handleOnChangeTochtType}
                    onAangeslotenBijChange={this.handleOnChangeAangeslotenBij}
                    onTochtNietViaFederatieChange={this.handleOnChangeTochtNietViaFederatie}
                    onContactpersoonLandChange={this.handleOnChangeContactLand}
                    onDatumChange={this.handleOnChangeDatum}
                    onAddGemeente={this.handleOnAddGemeente}
                    onRemoveGemeente={this.handleOnRemoveGemeente}
                    onChangeGemeente={this.handleOnChangeGemeente}
                    onChangeContactpersoonSelection={this.handleOnChangeContactpersoonSelection}
                    onSave={this.handleOnSave}
                    onAnnuleer={this.handleOnAnnuleer}
                    errors={this.state.errors}
                    validationMessageType={validationMessageType}
                    disabled={false}
                    dagenNodigVoorMachtiging={this.props.dagenNodigVoorMachtiging}
                    onHandleOpenKopieerGegevensTochtModal={this.handleOpenKopieerGegevensTochtModal}
                    organisatorHadAlFederatie={this.state.organisatorHadAlFederatie}
                    showTeLaatPopup={this.state.showTeLaatPopup}
                    onConfirmTeLaatPopup={this.handleOnConfirmTeLaatPopup}
                />

                <Modal
                    open={this.state.kopieerModalIsOpen}
                    style={modalStyle}
                    className="scrolling"
                    >
                    <Modal.Content>
                        <KopieerTochtGegevensComponent
                            onSelectTocht={this.handleOnSelectTeKopierenTocht}
                            tochten={this.state.kopieerbareTochten}
                            tochtTypes={this.state.tochtTypes}
                            fetchedKopieerbareTochten={this.state.fetchedKopieerbareTochten}
                            />
                    </Modal.Content>
                    <Modal.Actions className={"c-form__actions"}>
                        <Button  className={"c-button--left"} onClick={this.handleCloseKopieerGegevensTochtModal} autoFocus text={"Annuleer"} />
                    </Modal.Actions>
                </Modal>
                </div>);
    }
}

TochtPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state) {
    const landen = state.referentie.landen;
    const gemeenten = state.referentie.gemeenten;
    const postcodes = state.referentie.postcodes;

    return {
        landen: landen,
        gemeenten: gemeenten,
        postcodes: postcodes,
        dagenNodigVoorMachtiging: state.settings.dagenNodigVoorMachtiging
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadTochtPageLayout, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TochtPage);